import { render, staticRenderFns } from "./Molecule.vue?vue&type=template&id=184980dc&scoped=true&"
import script from "./Molecule.vue?vue&type=script&lang=js&"
export * from "./Molecule.vue?vue&type=script&lang=js&"
import style0 from "./Molecule.vue?vue&type=style&index=0&id=184980dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184980dc",
  null
  
)

export default component.exports